import { createAction } from "@reduxjs/toolkit";

export const setPreviousPath = createAction("utilities/setPreviousPath");
